<template>
    <div class="booking-trip">
        <div class="trip-header"> 
            <h3>Trip {{ tripIndex + 1 }}</h3>
            <div class="trip-header-slot">
                <slot name="header" />
            </div>
        </div>
        <BookingPassengers 
            v-model="trip.passengers" 
            :trip-id="trip.id"
            :errors="errors"
        />
        <BookingRoute 
            v-model:start-location="trip.start_location" 
            v-model:end-location="trip.end_location"
            :trip-id="trip.id"
            :booking-service="bookingService"
            :errors="errors"
        />
        <BookingDateTime 
            v-model:trip-route="trip.route" 
            v-model:booking-day="trip.booking_day"
            :trip-id="trip.id"
            :trip-options="tripOptions"
            :errors="errors"
        />
        <div>
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
import BookingRoute from '@/views/booking/BookingRoute.vue';
import BookingPassengers from '@/views/booking/BookingPassengers.vue';
import BookingDateTime from '@/views/booking/BookingDateTime.vue';

export default {
    components: { BookingRoute, BookingPassengers, BookingDateTime },
    props: {
        modelValue: Object,
        bookingService: Object,
        tripIndex: Number,
        errors: Object
    },
    data() {
        return {
            tripOptions: [],
        }
    },
    computed: {
        trip: {
            get() { 
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },

        passengerParams() {
            return [
                this.trip.passengers.adults,
                this.trip.passengers.children_under16,
                this.trip.passengers.children_under1
            ];
        },

        searchParams() {
            return [
                this.passengerParams,
                this.trip.start_location,
                this.trip.end_location
            ]
        },

        numPassengers() {
            return this.trip.passengers.adults +
                this.trip.passengers.children_under16 +
                this.trip.passengers.children_under1;
        }
    },
    watch: {
        searchParams() {
            this.updateOptions();
        }
    },
    methods: {
        updateOptions() {
            if (
                this.trip.start_location === null || 
                this.trip.end_location === null ||
                this.numPassengers <= 0
            ) {
                this.tripOptions = [];
                return;
            }

            this.bookingService.getOptions(
                this.trip.start_location, 
                this.trip.end_location, 
                this.numPassengers
            ).then(data => {
                this.tripOptions = data;
            });
        }
    },
    created() {
        this.updateOptions();
    }
}
</script>

<style lang="scss">
.booking-trip {
    margin: 20px 0 40px;
    padding: 15px;
    border-radius: 10px;
    background-color: #EBF7FA;

    .trip-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;

        h3 {
            flex: 1 0;
        }

        .trip-header-slot {
            flex: 0 1;
        }
    }
}
</style>